import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-quill-new/dist/quill.bubble.css';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import { configureStore } from '@reduxjs/toolkit';

import 'antd/dist/reset.css';

import App from './App';
import history from './history';
import './index.css';
import { rootReducer } from './storage/RootStorage';

const store = configureStore({
    reducer: rootReducer,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <HistoryRouter history={history as any}>
            <Provider store={store}>
                <App />
            </Provider>
        </HistoryRouter>
    </React.StrictMode>,
);
